import { render, staticRenderFns } from "./gameRender.vue?vue&type=template&id=172e8a7e&scoped=true&"
import script from "./gameRender.vue?vue&type=script&lang=js&"
export * from "./gameRender.vue?vue&type=script&lang=js&"
import style0 from "./gameRender.vue?vue&type=style&index=0&id=172e8a7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172e8a7e",
  null
  
)

export default component.exports